<div class="flex flex-wrap justify-content-between align-items-center my-3">
    <div class="flex flex-column">
        <h2 class="m-0 font-semibold text-base">Vehicles</h2>
        <span class="sub-title mt-2">{{ totalRecords() }} in fleet · {{ modelsCount() }} models · {{ availableCarsCount() }} available</span>
    </div>
    @if ([UserRole.ADMIN, UserRole.FLEET_MANAGER,
    UserRole.SUPER_ADMIN].includes(employee()?.role!)) {
    <div class="flex gap-2">
        <!-- <p-button label="Import" styleClass="text-sm" variant="text"></p-button> -->
        <p-button label="Export" class="export-btn" styleClass="add-button" variant="text" [disabled]="true">
            <ng-template #icon>
                <img src="assets/icons/download.svg" alt="Send" />
            </ng-template>
        </p-button>
        @if (activeTab() === '0') {
        <p-button styleClass="add-button text-xs" label="Add Vehicle" severity="primary" (onClick)="openAddCarDialog()">
            <ng-template #icon>
                <img width="15" height="15" src="assets/icons/Add.svg" alt="Send" />
            </ng-template>
        </p-button>
        }
        @if (activeTab() === 'models') {
        <p-button styleClass="add-button text-xs" label="Add Model" severity="primary" (onClick)="router.navigate(['/model-form'])">
            <ng-template #icon>
                <img width="15" height="15" src="assets/icons/Add.svg" alt="Send" />
            </ng-template>
        </p-button>
        }
    </div>
    }
</div>

<div class="details-container">

    <p-tabs [value]="activeTab()" (valueChange)="onTabChange($event)" class="tabs--rental">

        <p-tablist>
            <p-tab value="0">
                <span>Cars</span>
                <span class="tab-total-badge">{{ totalRecords() }}</span>
            </p-tab>
            <p-tab value="models">
                <span>Models</span>
                <span class="tab-total-badge">{{ modelsCount() }}</span>
            </p-tab>
        </p-tablist>

        <p-tabpanels>

            <p-tabpanel value="0">
                <app-cars-list [cars]="cars()" [totalRecords]="totalRecords()" [rows]="rows" [first]="first"
                    [searchControl]="searchControl" [modelsFilter]="modelsFilter" (pageChange)="onPageChange($event)"
                    (searchChange)="onSearchChange()" (reloadCars)="getCarsList()">
                </app-cars-list>
            </p-tabpanel>

            <p-tabpanel value="models">
                @if (modelsLoaded) {
                <app-models-list-component></app-models-list-component>
                }
            </p-tabpanel>

        </p-tabpanels>

    </p-tabs>

</div>

@defer (when addCarDialog; prefetch on idle) {
<app-add-car-form (addedCar)="onCarAdded()" [(visibility)]="addCarDialog" />
}